import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/location-frame-v2.svg'
import _imports_1 from '@/assets/flag-frame-v2.svg'
import _imports_2 from '@/assets/star-frame-v2.svg'


const _hoisted_1 = { class: "w-full grid grid-cols-3 items-center gap-[12.5px] mt-5" }
const _hoisted_2 = {
  key: 0,
  class: "bg-white rounded-primary-radius p-3"
}
const _hoisted_3 = { class: "flex items-center gap-2 mb-3" }
const _hoisted_4 = { class: "text-primary-text-color text-base custom-xl:text-lg leading-5 tracking-[0.01rem] font-semibold" }
const _hoisted_5 = { class: "text-primary-text-color text-base custom-xl:text-lg leading-[22.5px] tracking-[0.01rem] font-normal" }
const _hoisted_6 = {
  key: 1,
  class: "bg-white rounded-primary-radius p-3"
}
const _hoisted_7 = { class: "flex items-center gap-2 mb-3" }
const _hoisted_8 = { class: "text-primary-text-color text-base custom-xl:text-lg leading-5 tracking-[0.01rem] font-semibold" }
const _hoisted_9 = { class: "text-primary-text-color text-base custom-xl:text-lg leading-[22.5px] tracking-[0.01rem] font-normal" }
const _hoisted_10 = { class: "bg-white rounded-primary-radius p-3" }
const _hoisted_11 = { class: "flex items-center gap-2 mb-3" }
const _hoisted_12 = { class: "text-primary-text-color text-base custom-xl:text-lg leading-5 tracking-[0.01rem] font-semibold" }
const _hoisted_13 = { class: "text-primary-text-color text-base custom-xl:text-lg leading-[22.5px] tracking-[0.01rem] font-normal" }
const _hoisted_14 = { class: "bg-white rounded-primary-radius p-3" }
const _hoisted_15 = { class: "flex items-center gap-2 mb-3" }
const _hoisted_16 = { class: "text-primary-text-color text-base custom-xl:text-lg leading-5 tracking-[0.01rem] font-semibold" }
const _hoisted_17 = { class: "w-full flex items-center justify-between" }
const _hoisted_18 = { class: "w-full flex items-center" }
const _hoisted_19 = { class: "text-primary-text-color text-base custom-xl:text-lg leading-[22.5px] tracking-[0.01rem] font-normal" }
const _hoisted_20 = { class: "text-primary-text-color text-base custom-xl:text-lg leading-[22.5px] tracking-[0.01rem] font-normal" }
const _hoisted_21 = { class: "text-primary-text-color text-base custom-xl:text-lg leading-[22.5px] tracking-[0.01rem] font-normal" }

import { useTranslate } from "@/composables/useTranslate";


type Props = {
  currentAppointment?: string;
  completedTermins?: number;
  completedTerminsPercentage?: number;
  bonus?: number;
  termins?: number;
  isReport: boolean;
};

export default /*@__PURE__*/_defineComponent({
  __name: 'InstallerProfileThreeBlocks',
  props: {
    currentAppointment: {},
    completedTermins: {},
    completedTerminsPercentage: {},
    bonus: {},
    termins: {},
    isReport: { type: Boolean }
  },
  setup(__props: any) {

const { t } = useTranslate();



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!__props.isReport)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[0] || (_cache[0] = _createElementVNode("img", {
              src: _imports_0,
              alt: "Appointment"
            }, null, -1)),
            _createElementVNode("h4", _hoisted_4, _toDisplayString(_unref(t)("installers.current_appointment")), 1)
          ]),
          _createElementVNode("span", _hoisted_5, _toDisplayString(__props.currentAppointment ? __props.currentAppointment : _unref(t)("installers.none")), 1)
        ]))
      : _createCommentVNode("", true),
    (__props.isReport)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _cache[1] || (_cache[1] = _createElementVNode("img", {
              src: _imports_1,
              alt: "Appointment month"
            }, null, -1)),
            _createElementVNode("h4", _hoisted_8, _toDisplayString(_unref(t)("installers.bonus")), 1)
          ]),
          _createElementVNode("span", _hoisted_9, _toDisplayString(__props.bonus ? `${__props.bonus}€` : 0), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _cache[2] || (_cache[2] = _createElementVNode("img", {
          src: _imports_1,
          alt: "Appointment month"
        }, null, -1)),
        _createElementVNode("h4", _hoisted_12, _toDisplayString(_unref(t)("installers.appointments_this_month")), 1)
      ]),
      _createElementVNode("span", _hoisted_13, _toDisplayString(__props.termins ? __props.termins : 0), 1)
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _cache[3] || (_cache[3] = _createElementVNode("img", {
          src: _imports_2,
          alt: "Success rate"
        }, null, -1)),
        _createElementVNode("h4", _hoisted_16, _toDisplayString(_unref(t)("installers.success_rate")), 1)
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("span", _hoisted_19, _toDisplayString(__props.completedTermins ? __props.completedTermins : "0"), 1),
          _cache[4] || (_cache[4] = _createElementVNode("span", { class: "text-primary-text-color text-base custom-xl:text-lg leading-[22.5px] tracking-[0.01rem] font-normal" }, "/", -1)),
          _createElementVNode("span", _hoisted_20, _toDisplayString(__props.termins ? __props.termins : "0"), 1)
        ]),
        _createElementVNode("span", _hoisted_21, _toDisplayString(__props.completedTerminsPercentage ? `${__props.completedTerminsPercentage}%` : "0%"), 1)
      ])
    ])
  ]))
}
}

})